// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"2ac0489a","513":"806a44a2","545":"90dbe27f"}[chunkId] + ".chunk.js";
};